import { cn } from "@/lib/utils";
import {
  Chemistry,
  DetailedPlayerAction,
} from "@/pages/DetailedPlayer/reducer";

export const ChemistryIcon = ({
  selected,
  hovered,
  chemistry,
}: {
  selected: boolean;
  hovered: boolean;
  chemistry: Chemistry;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.44444 7.55556L8.88889 12L4.44444 16.4444L0 12L4.44444 7.55556Z"
      fill={
        (selected || hovered) && chemistry > 0
          ? "white"
          : chemistry > 0
            ? "var(--color-primary-action)"
            : "var(--color-gray-800)"
      }
    />
    <path
      d="M10 2L14.4444 6.44444L10 10.8889L5.55556 6.44444L10 2Z"
      fill={
        (selected || hovered) && chemistry > 1
          ? "white"
          : chemistry > 1
            ? "var(--color-primary-action)"
            : "var(--color-gray-800)"
      }
    />
    <path
      d="M15.5556 7.55556L20 12L15.5556 16.4444L11.1111 12L15.5556 7.55556Z"
      fill={
        (selected || hovered) && chemistry > 2
          ? "white"
          : chemistry > 2
            ? "var(--color-primary-action)"
            : "var(--color-gray-800)"
      }
    />
  </svg>
);

const ChemistryButton = ({
  chemistry,
  selected,
  hovered,
  onClick,
  onMouseEnter,
}: {
  chemistry: Chemistry;
  selected: boolean;
  hovered: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}) => {
  return (
    <button
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={cn(
        "w-10 mobile:w-15 h-9 mobile:h-7 rounded bg-action-tertiary hover:bg-action-tertiary-hover flex flex-row items-center justify-center shadow-soft-dark-bottom max-mobile:shrink-0",
        selected && "bg-action-tertiary-active",
        hovered && "bg-action-tertiary-hover",
      )}
    >
      <ChemistryIcon
        chemistry={chemistry}
        selected={selected}
        hovered={hovered}
      />
    </button>
  );
};

export const ChemistrySection = ({
  selectedChemistry,
  hoveredChemistry,
  handleAction,
}: {
  selectedChemistry: Chemistry;
  hoveredChemistry: Chemistry;
  handleAction: (action: DetailedPlayerAction) => void;
}) => {
  return (
    <div
      className="flex flex-row gap-x-1 items-center col-span-1"
      onMouseLeave={() => {
        handleAction({ type: "SET_TEMPORARY_CHEMISTRY", payload: undefined });
      }}
    >
      <ChemistryButton
        chemistry={0}
        selected={selectedChemistry === 0}
        hovered={hoveredChemistry === 0}
        onClick={() => {
          handleAction({ type: "SET_CHEMISTRY", payload: 0 });
        }}
        onMouseEnter={() => {
          handleAction({ type: "SET_TEMPORARY_CHEMISTRY", payload: 0 });
        }}
      />
      <ChemistryButton
        chemistry={1}
        selected={selectedChemistry === 1}
        hovered={hoveredChemistry === 1}
        onClick={() => {
          handleAction({ type: "SET_CHEMISTRY", payload: 1 });
        }}
        onMouseEnter={() => {
          handleAction({ type: "SET_TEMPORARY_CHEMISTRY", payload: 1 });
        }}
      />
      <ChemistryButton
        chemistry={2}
        selected={selectedChemistry === 2}
        hovered={hoveredChemistry === 2}
        onClick={() => {
          handleAction({ type: "SET_CHEMISTRY", payload: 2 });
        }}
        onMouseEnter={() => {
          handleAction({ type: "SET_TEMPORARY_CHEMISTRY", payload: 2 });
        }}
      />
      <ChemistryButton
        chemistry={3}
        selected={selectedChemistry === 3}
        hovered={hoveredChemistry === 3}
        onClick={() => {
          handleAction({ type: "SET_CHEMISTRY", payload: 3 });
        }}
        onMouseEnter={() => {
          handleAction({ type: "SET_TEMPORARY_CHEMISTRY", payload: 3 });
        }}
      />
    </div>
  );
};
